import { WarningTwoIcon } from "@chakra-ui/icons";
import { BoxProps, Heading, ListItem, Text, UnorderedList, VStack } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

interface ErrorBoxProps extends BoxProps {
  errors?: string[];
}

export function ErrorBox({ errors = [], children, ...rest }: ErrorBoxProps) {
  if (errors.length === 0) return null;

  return (
    <VStack bgColor="bij12_1.50" color="bij12_1.500" p="20px" rounded="lg" w="full" {...rest}>
      <Heading w="100%">
        <WarningTwoIcon boxSize={6} mr={4} />
        <FormattedMessage id="error.present" defaultMessage="There were errors" />
        <Text
          as="span"
          color="bij12_1.700"
          fontWeight="semibold"
          bgColor="#CC614D20"
          rounded="full"
          px="14px"
          py="1px"
          ml="12px"
        >
          {errors.length ?? 0}
        </Text>
      </Heading>
      <UnorderedList w="100%" p={4}>
        {errors.map((error, idx) => (
          <ListItem key={idx}>
            <Text fontWeight="semibold">{error}</Text>
          </ListItem>
        ))}
      </UnorderedList>
      {children}
    </VStack>
  );
}
